export default __webpack_public_path__ + "images/29aa83b5f2a690bf83c23a0328a6eda0.svg";